import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImmunizationData } from '../../../models';

@Component({
  selector: 'app-immunization-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './immunization-table.component.html',
})
export class ImmunizationTableComponent {
  readonly immunizations = input.required<ImmunizationData[]>();

  formatDate(date: string): string {
    if (!date) return '';
    return /^\d{4}-\d{2}-\d{2}/.test(date) ? date.slice(0, 10) : date;
  }

  getEstadoBadge(estado: string): { color: string; label: string } {
    const s = (estado || '').toLowerCase();
    if (s === 'completed') return { color: 'bg-success', label: 'Completado' };
    if (s === 'entered-in-error') return { color: 'bg-danger', label: 'Error de Entrada' };
    if (s === 'not-done') return { color: 'bg-warning text-dark', label: 'No Aplicado' };
    return { color: 'bg-secondary', label: estado || '—' };
  }
}
